import type { ReactNode } from 'react'

import { amtcDialNumber, amtcDisplayNumber } from '../../lib/amtc'

/** " on +233 …" as a tel: link, or nothing when no desk number is set, so
 * "Call the transport desk<Desk />." reads right either way. */
export function Desk(): ReactNode {
  const dial = amtcDialNumber()
  if (!dial) return null
  return (
    <>
      {' on '}
      <a
        href={`tel:${dial}`}
        className="font-semibold text-accent underline underline-offset-2"
      >
        {amtcDisplayNumber() ?? dial}
      </a>
    </>
  )
}
